import CommunityProps from 'Components/Dashboard/Interfaces/CommunityProp';

const CommunityDataState: CommunityProps[] = [];

export default CommunityDataState;
